"use strict";

var _classCallCheck = require("/home/javier/sources/resume/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/javier/sources/resume/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = void 0;

var Bubble_1 = require("./Bubble");

var Connect_1 = require("./Connect");

var Grab_1 = require("./Grab");

var Remove_1 = require("./Remove");

var Push_1 = require("./Push");

var Repulse_1 = require("./Repulse");

var Slow_1 = require("./Slow");

var Trail_1 = require("./Trail");

var Attract_1 = require("./Attract");

var Light_1 = require("./Light");

var Bounce_1 = require("./Bounce");

var Modes = /*#__PURE__*/function () {
  function Modes() {
    _classCallCheck(this, Modes);

    this.attract = new Attract_1.Attract();
    this.bounce = new Bounce_1.Bounce();
    this.bubble = new Bubble_1.Bubble();
    this.connect = new Connect_1.Connect();
    this.grab = new Grab_1.Grab();
    this.light = new Light_1.Light();
    this.push = new Push_1.Push();
    this.remove = new Remove_1.Remove();
    this.repulse = new Repulse_1.Repulse();
    this.slow = new Slow_1.Slow();
    this.trail = new Trail_1.Trail();
  }

  _createClass(Modes, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      this.attract.load(data.attract);
      this.bubble.load(data.bubble);
      this.connect.load(data.connect);
      this.grab.load(data.grab);
      this.light.load(data.light);
      this.push.load(data.push);
      this.remove.load(data.remove);
      this.repulse.load(data.repulse);
      this.slow.load(data.slow);
      this.trail.load(data.trail);
    }
  }]);

  return Modes;
}();

exports.Modes = Modes;